import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppMessageEventQueryCriteriaClass extends BaseCriteriaModel {
  local_created_time_from?: Optional<string> = Optional.empty();
  local_created_time_to?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  link_guid?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
}

export class AppMessageEventCriteriaModelQuery {
  query = '';

  constructor(appMessageEventCriteriaModel: AppMessageEventQueryCriteriaClass) {

    if (!appMessageEventCriteriaModel) {
      return;
    }

    this.query += appMessageEventCriteriaModel.local_created_time_from.filter(x => x !== '').map(x => '&local_created_time_from=' + x).orElse('');
    this.query += appMessageEventCriteriaModel.local_created_time_to.filter(x => x !== '').map(x => '&local_created_time_to=' + x).orElse('');
    this.query += appMessageEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += appMessageEventCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += appMessageEventCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += appMessageEventCriteriaModel.link_guid.filter(x => x !== '').map(x => '&link_guid=' + x).orElse('');
    this.query += appMessageEventCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');

    this.query += '&status=' + appMessageEventCriteriaModel.status;
    this.query += '&orderBy=' + appMessageEventCriteriaModel.orderBy;
    this.query += '&order=' + appMessageEventCriteriaModel.order;
    this.query += '&offset=' + appMessageEventCriteriaModel.offset + '&limit=' + appMessageEventCriteriaModel.limit;
  }
}
